import { Outlet } from 'react-router-dom';

import { CVAnalysisLayout } from '@/features/cv-analysis';

export const CVAnalysisRootLayout: React.FC = () => {
  return (
    <CVAnalysisLayout>
      <Outlet />
    </CVAnalysisLayout>
  );
};
